import { createActionGroup, props } from "@ngrx/store";
import { ProtocolScope } from "./protocol.state";

export const protocolPanelActions = createActionGroup({
  source: "ProtocolPanel",
  events: {
    "Set Scope": props<{ scope: ProtocolScope }>(),
    "Select Sample": props<{ sampleId: string }>(),
    "Select Sample Success": props<{ methodType: string }>(),
  },
});